import { groupBy } from "../utils/groupBy";
import { SimpleFilterResultsInfo } from "../components/SimpleFilterResultsInfo";
import { Fault } from "../components/FilterResultHeader/FilterResultHeader";

export function getWarningInfos(
  clientDefaultInfos: SimpleFilterResultsInfo[],
  faults: Fault[],
): SimpleFilterResultsInfo[] {
  const activeFaults = faults.filter((p) => p.constraintCount > 0);
  const faultGroups = groupBy(activeFaults, "name") as Record<string, Fault[]>;
  const infos: SimpleFilterResultsInfo[] = [];

  const getFaultSeason = (faultsForName: Fault[]): string =>
    faultsForName.reduce((m, f) => (m < f.season ? m : f.season), faultsForName[0]?.season ?? "");

  clientDefaultInfos.forEach((info) => {
    const faultGroup = faultGroups[info.name];
    if (!faultGroup) return;

    if (info.hasOptions) {
      const valueToSelect = faultGroup.some((f) => f.nonSeasonalValue === info.value)
        ? info.value
        : faultGroup[0].nonSeasonalValue;

      const faultSeason = getFaultSeason(
        faultGroup.filter((g) => g.nonSeasonalValue === valueToSelect),
      );

      infos.push(new SimpleFilterResultsInfo(true, info.name, faultSeason, valueToSelect, true));
    } else {
      const faultSeason = getFaultSeason(faultGroup);
      infos.push(new SimpleFilterResultsInfo(true, info.name, faultSeason, info.value, false));
    }
  });

  return infos;
}
